import { WaitlistShowcase } from '../components/waitlist/WaitlistShowcase';
import { usePageSeo } from '../hooks/usePageSeo';
import { PAGE_SEO } from '../lib/seo';
import '../styles/waitlist-page.css';

export function WaitlistPage() {
  usePageSeo(PAGE_SEO.waitlist);

  return <WaitlistShowcase />;
}
